"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChallengeFactory = void 0;
// Components
const otp_1 = require("./otp");
const trusted_1 = require("./trusted");
const trustedLogin_1 = require("./trustedLogin");
const signatureKey_1 = require("./signatureKey");
const otpIvr_1 = require("./otpIvr");
const signatureKeyIvr_1 = require("./signatureKeyIvr");
const types_1 = require("../../../security/authoriser/types");
class ChallengeFactory {
    constructor(api, session, manager) {
        this.api = api;
        this.session = session;
        this.manager = manager;
    }
    // eslint-disable-next-line complexity
    getChallenge(data) {
        switch (data.type) {
            case types_1.ChallengeType.OTP:
                return new otp_1.MbOtp(this.api, data);
            case types_1.ChallengeType.OTP_LOGIN:
                return new otp_1.MbOtpLogin(this.api, data);
            case types_1.ChallengeType.TRUSTED_CONFIRMATION:
                return new trusted_1.MbTrusted(this.api, data, this.session);
            case types_1.ChallengeType.TRUSTED_CONFIRMATION_LOGIN:
                return new trustedLogin_1.MbTrustedLogin(this.api, data, this.session);
            case types_1.ChallengeType.SIGNATURE_KEY:
                return new signatureKey_1.MbSignatureKey(this.api, data);
            case types_1.ChallengeType.OTP_IVR:
                return new otpIvr_1.MbOtpIvr(this.api, data, this.manager);
            case types_1.ChallengeType.SIGNATURE_KEY_IVR:
                return new signatureKeyIvr_1.MbSignatureKeyIvr(this.api, data, this.manager);
            case types_1.ChallengeType.NONE:
            default:
                return null;
        }
    }
}
exports.ChallengeFactory = ChallengeFactory;
//# sourceMappingURL=challengeFactory.js.map